import styled, { css } from 'styled-components';
import { flexColumn } from '@stylesheets/helpers';

export const Wrapper = styled.div`
  height: 100%;
  ${flexColumn};
`;

export const ContentWrapper = styled.div`
  flex: 1;
  overflow-y: auto;

  ${({ theme: { spacing } }) => css`
    padding-bottom: ${spacing.level6};
  `}
`;

export const ContentInner = styled.div`
  width: 100%;
  max-width: 1100px;
`;

export const Frame = styled.div`
  ${flexColumn};

  ${({ theme: { colors, borderRadius, spacing } }) => css`
    border-radius: ${borderRadius.large};
    background-color: ${colors.surfaceContainer};
    padding: ${spacing.level4};
  `}
`;

export const TableContainer = styled.div`
  overflow-x: auto;
  width: 100%;
`;
